//
import React, { ReactElement, useEffect, useState } from 'react';
import {
  Keyboard,
  ScrollView,
  StyleProp,
  StyleSheet,
  Text,
  View,
  ViewStyle,
  Dimensions
} from 'react-native';
import colors from '../../colors';
import { TXT_M, MAX_WIDTH, HEADER_HEIGHT, DEVICE_HEIGHT, SIDE_PADDING } from '../../constants';
import Touchable from '../Generic/Touchable';
import { useIsBigScreen, conditionalStyle } from '../../helper';

const BUTTON_HEIGHT = 45;

type Props = {
  onPress: () => void;
  buttonTitle: string;
  buttonColor?: string;
  startIcon?: React.ReactElement;
  style?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  refreshControl?: ReactElement;
};

const ScrollComBotao: React.FC<Props> = (props) => {
  const {
    onPress,
    buttonTitle,
    style,
    containerStyle,
    startIcon,
    buttonColor,
    refreshControl
  } = props;

  const [keyboarUp, setKeyboarUp] = useState(false);
  const isBigScreen = useIsBigScreen();

  useEffect(() => {
    Keyboard.addListener('keyboardDidShow', () => setKeyboarUp(true));
    Keyboard.addListener('keyboardDidHide', () => setKeyboarUp(false));

    return () => {
      Keyboard.removeListener('keyboardDidShow', () => {});
      Keyboard.removeListener('keyboardDidHide', () => {});
    };
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        contentContainerStyle={[
          styles.container,
          conditionalStyle(isBigScreen, styles.constainerBig),
          containerStyle
        ]}
        refreshControl={refreshControl}
      >
        {props.children}
      </ScrollView>
      {keyboarUp === false && (
        <Touchable
          onPress={onPress}
          style={[
            styles.botao,
            {
              backgroundColor: buttonColor ? buttonColor : colors.green
            }
          ]}
        >
          {startIcon}
          <Text style={styles.txtBotao}>{buttonTitle}</Text>
        </Touchable>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  botao: {
    backgroundColor: colors.green,
    width: '100%',
    maxWidth: 600,
    height: BUTTON_HEIGHT,
    borderTopLeftRadius: 40,
    borderTopRightRadius: 40,
    position: 'absolute',
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    alignSelf: 'center'
  },
  container: {
    paddingBottom: BUTTON_HEIGHT + 20
  },
  constainerBig: {
    width: MAX_WIDTH,
    minHeight: DEVICE_HEIGHT - HEADER_HEIGHT,
    alignSelf: 'center',
    borderLeftWidth: 2,
    borderRightWidth: 2,
    borderColor: colors.veryLightGrey
  },
  txtBotao: {
    color: '#fff',
    fontSize: TXT_M,
    fontWeight: '700'
  }
});

export default ScrollComBotao;
